import React from "react";
import { CheckIcon } from "@heroicons/react/20/solid"; // Use the solid version for filled icons
import { useNavigate } from "react-router-dom";
import "./carousel.css";

const benefits = [
  "Training Load & RPE",
  "Recovery Modals",
  "Injuries / Niggles",
  "Soreness",
  "Performances",
  "Personal Bests",
  "Wellness",
  "Sleep",
  "Stress",
  "Female Cyles",
  "Notes",
];

export default function CreatineBenefits() {
  const navigate = useNavigate();

  return (
    <section className="bg-base-100 pt-24 flex flex-col items-center gap-20 md:gap-40 pb-16">
      <div className="flex flex-col gap-10 md:gap-20 w-full">
        <div className="flex flex-col gap-12">
          <div className="flex flex-col gap-4 max-w-4xl mx-auto px-6">
            <h2 className="text-4xl md:text-5xl font-semibold font-grotesk text-center">
              How It Works
            </h2>
            <p className="text-xl text-center font-grotesk text-base-content/70">
              Three simple steps to unlock elite-level performance insights.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto w-full px-6 text-center">
          <div className="flex flex-col items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-base-content text-base-100 flex items-center justify-center text-xl font-bold font-heading">
              1
            </div>
            <h3 className="text-xl font-semibold font-grotesk">
              Log Wellness
            </h3>
            <p className="text-sm font-grotesk text-base-content/70 leading-relaxed">
              A quick daily check-in on how you feel — mood, sleep, stress,
              recovery, and physical state.
            </p>
          </div>
          <div className="flex flex-col items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-base-content text-base-100 flex items-center justify-center text-xl font-bold font-heading">
              2
            </div>
            <h3 className="text-xl font-semibold font-grotesk">
              Log Training Load & Activities
            </h3>
            <p className="text-sm font-grotesk text-base-content/70 leading-relaxed">
              Record your training session with RPE and duration. Sync activities from your wearable device.
            </p>
          </div>
          <div className="flex flex-col items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-base-content text-base-100 flex items-center justify-center text-xl font-bold font-heading">
              3
            </div>
            <h3 className="text-xl font-semibold font-grotesk">
              Get Individualised Insights
            </h3>
            <p className="text-sm font-grotesk text-base-content/70 leading-relaxed">
              Your Peak Score and personalised insights update in real-time, helping you decide when to push and when to recover.
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center font-grotesk">
          <button
            onClick={() => navigate("/onboarding")}
            className="bg-primary text-primary-content border-none rounded-full px-8 py-3 text-base font-medium hover:opacity-80 transition-opacity duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Get Started
          </button>
        </div>
        <div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] overflow-hidden">
          <div className="flex animate-scroll">
            <div className="flex gap-3 shrink-0">
              {benefits.map((item, index) => (
                <div
                  key={`first-${index}`}
                  className="flex items-center gap-2 bg-base-200 text-base-content px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap font-geist"
                >
                  <CheckIcon className="w-4 h-4 text-base-content" />
                  {item}
                </div>
              ))}
            </div>
            <div className="flex gap-3 shrink-0 ml-3">
              {benefits.map((item, index) => (
                <div
                  key={`second-${index}`}
                  className="flex items-center gap-2 bg-base-200 text-base-content px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap font-geist"
                >
                  <CheckIcon className="w-4 h-4 text-base-content" />
                  {item}
                </div>
              ))}
            </div>
            <div className="flex gap-3 shrink-0 ml-3">
              {benefits.map((item, index) => (
                <div
                  key={`third-${index}`}
                  className="flex items-center gap-2 bg-base-200 text-base-content px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap font-geist"
                >
                  <CheckIcon className="w-4 h-4 text-base-content" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* 
      <div className="max-w-4xl mx-auto">
        <h2 className="text-5xl font-semibold font-grotesk mb-5">
          Peak is an app that enables you to train like an Athlete. <br></br>
        </h2>
        <h3 className="font-light text-2xl mb-10 text-base-content/60 ">
          No complex or expensive devices required. Simply track the data that
          matters & optimise your peak performance.
        </h3>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {benefits.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-2 bg-base-200 font-grotesk text-base-content px-4 py-2 rounded-3xl text-md font-medium"
            >
              <CheckIcon className="w-4 h-4 text-base-content" />
              {item}
            </div>
          ))}
        </div>
        <div className="mt-5">
          <img
            src={wearables}
            alt="Compatible wearable devices"
            className="mx-auto max-w-full h-auto"
          />
        </div>
        <div className="mt-5 bg-base-200 max-w-4xl mx-auto p-4 rounded-md">
          <h3 className="text-xl">
            Wearble data can be integrated to provide advanced insights, but not
            required.
          </h3>
          <p className="font-grotesk text-sm">
            We believe paid wearable tools can be useful, but not critical for
            elite performance.
          </p>
        </div>
      </div> */}
    </section>
  );
}
